import CloudOffIcon from '@mui/icons-material/CloudOffRounded';
import { Typography } from '@mui/material';
import { useDebounce } from '@uidotdev/usehooks';
import React from 'react';
import { useTranslation } from 'react-i18next';
import config from '../../config';
import EmptyLayout from '../EmptyLayout';
import StyledBox from './styles';

export default function OfflineScreenWrapper(props: { children: React.ReactNode }) {
  const { children } = props;
  const [online, setOnline] = React.useState(window.navigator.onLine);
  const debouncedOnline = useDebounce(online, 1500);

  React.useEffect(() => {
    const handleOnline = () => setOnline(true);
    const handleOffline = () => setOnline(false);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);
  const { t } = useTranslation();

  const url = React.useMemo(() => {
    const environment = config.Environment;
    let baseUrl = config.BaseUrl;
    if (baseUrl.endsWith('/')) { baseUrl = baseUrl.slice(0, -1); }
    return `${baseUrl}/assets/${environment}/logo192.png`;
  }, []);

  if (!debouncedOnline || !online) {
    return (
      <EmptyLayout>
        <StyledBox className="content">
          <img src={url} alt={t('offline.img-alt') ?? undefined} />
          <Typography variant="body1">
            <CloudOffIcon />
            {t('offline.description')}
          </Typography>
        </StyledBox>
      </EmptyLayout>
    );
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return (<>{children}</>);
}
